/* tslint:disable */
/* eslint-disable */
/**
 * Spazious Backoffice API
 * Spazious private JSON:API v3 specification
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface Apiv3backofficebookingordersDataAttributes
 */
export interface Apiv3backofficebookingordersDataAttributes {
    /**
     * 
     * @type {number}
     * @memberof Apiv3backofficebookingordersDataAttributes
     */
    attendees?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof Apiv3backofficebookingordersDataAttributes
     */
    customerNotificationAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficebookingordersDataAttributes
     */
    endDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficebookingordersDataAttributes
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficebookingordersDataAttributes
     */
    overdueDate?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Apiv3backofficebookingordersDataAttributes
     */
    requestsAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficebookingordersDataAttributes
     */
    segmentationType?: Apiv3backofficebookingordersDataAttributesSegmentationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficebookingordersDataAttributes
     */
    startDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficebookingordersDataAttributes
     */
    status?: Apiv3backofficebookingordersDataAttributesStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum Apiv3backofficebookingordersDataAttributesSegmentationTypeEnum {
    CONGRESS = 'CONGRESS',
    GROUPTRAVEL = 'GROUP_TRAVEL',
    INCENTIVES = 'INCENTIVES',
    MEETINGORCONFERENCE = 'MEETING_OR_CONFERENCE',
    SOCIALEVENT = 'SOCIAL_EVENT',
    WEDDING = 'WEDDING'
}
/**
    * @export
    * @enum {string}
    */
export enum Apiv3backofficebookingordersDataAttributesStatusEnum {
    Blocked = 'blocked',
    Canceled = 'canceled',
    Confirmed = 'confirmed',
    Closed = 'closed',
    Draft = 'draft',
    DraftBackoffice = 'draft-backoffice',
    Option = 'option',
    Tentative = 'tentative',
    Potential = 'potential',
    Turndown = 'turndown'
}

